enum contactTypes {
    phoneNumber = "PhoneNumber",
    email = "Email",
    address = "Address",
  }
  
export default contactTypes;
  